/* Mr Mattress heavy people page v2 (preview, top of funnel order). No libraries.
   1. fade in on scroll (and the weight bars grow)  2. sticky "Shop the Ultra 200" bar: appears only after the guide section starts,
   steps aside over the page's own gold buttons and at the end of the page  3. size select updates the Ultra 200 card price and link
   4. links to something inside a closed row open the row first.
   If this file never loads, nothing is hidden and every button still works. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  root.classList.add('hp2-page');

  /* 1. reveal on scroll. Anything already in view is marked in before the hidden state is switched on, so nothing flashes. */
  var rv = [].slice.call(d.querySelectorAll('.hp2-rv'));
  if (rv.length) {
    if (!hasIO || reduce) {
      rv.forEach(function (e) { e.classList.add('is-in'); });
    } else {
      var vh = window.innerHeight || 800;
      rv.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < vh * 0.92 && r.bottom > 0) e.classList.add('is-in'); });
      root.classList.add('hp2-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      rv.forEach(function (e) { if (!e.classList.contains('is-in')) io.observe(e); });
    }
  }

  /* 2. sticky bar */
  var bar = d.querySelector('[data-hp2-sticky]');
  if (bar && hasIO) {
    var live = {}, n = 0, barOn = false;
    var state = function () {
      var off = Object.keys(live).some(function (k) { return live[k]; });
      root.classList.toggle('hp2-sticky-off', off);
      root.classList.toggle('hp2-bar-on', barOn);
      root.classList.toggle('hp2-sticky-on', barOn && !off);
    };
    var hio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { live[en.target.__hp2id] = en.isIntersecting; });
      state();
    }, { threshold: 0.5 });
    [].forEach.call(d.querySelectorAll('[data-hp2-hide-sticky]'), function (el) { el.__hp2id = n++; live[el.__hp2id] = false; hio.observe(el); });
    var start = d.querySelector('[data-hp2-sticky-start]');
    if (start) {
      /* on only once the guide section is well into the screen (its top is in the upper 55 percent) or already behind us */
      new IntersectionObserver(function (entries) { var en = entries[entries.length - 1]; barOn = en.isIntersecting || en.boundingClientRect.top < 0; state(); }, { rootMargin: '0px 0px -45% 0px', threshold: 0 }).observe(start);
    }
    var endEl = d.querySelector('[data-hp2-end]');
    if (endEl) {
      new IntersectionObserver(function (entries) { var en = entries[entries.length - 1]; live.end = en.isIntersecting || en.boundingClientRect.top < 0; state(); }, { threshold: 0 }).observe(endEl);
    }
    state();
  }

  /* 3. size select on the Ultra 200 card */
  [].forEach.call(d.querySelectorAll('[data-hp2-size]'), function (sel) {
    var card = sel.closest('[data-hp2-pcard]');
    if (!card) return;
    var price = card.querySelector('[data-hp2-price]'), was = card.querySelector('[data-hp2-was]'), pay = card.querySelector('[data-hp2-pay]');
    var from = card.querySelector('[data-hp2-from]'), btn = card.querySelector('[data-hp2-cta]');
    var base = { price: price && price.textContent, was: was && was.textContent, pay: pay && pay.innerHTML, from: from && from.textContent, href: btn && btn.getAttribute('href') };
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      if (!o || !o.value) {
        if (price) price.textContent = base.price;
        if (was) was.textContent = base.was;
        if (pay) pay.innerHTML = base.pay;
        if (from) from.textContent = base.from;
        if (btn) btn.setAttribute('href', base.href);
        return;
      }
      if (from) from.textContent = '';
      if (price) price.textContent = o.getAttribute('data-price');
      if (was) was.textContent = o.getAttribute('data-was') || '';
      if (pay) pay.innerHTML = 'Flexible payments from <b>' + o.getAttribute('data-month') + '/mo</b>';
      if (btn) btn.setAttribute('href', base.href.split('?')[0] + '?variant=' + o.value);
    });
  });

  /* 4. a link to something inside a closed row opens the row first */
  function openFor(el) {
    var p = el && el.closest ? el.closest('details') : null;
    while (p) { p.open = true; p = p.parentElement && p.parentElement.closest ? p.parentElement.closest('details') : null; }
  }
  d.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var t = d.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    ev.preventDefault();
    openFor(t);
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
  if (location.hash.length > 1) { var h = d.getElementById(location.hash.slice(1)); if (h) openFor(h); }
})();
